import { render, staticRenderFns } from "./Lgx243684920157239864.vue?vue&type=template&id=3f38c4ce&scoped=true&"
import script from "./Lgx243684920157239864.vue?vue&type=script&lang=js&"
export * from "./Lgx243684920157239864.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243684920157239864.vue?vue&type=style&index=0&id=3f38c4ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38c4ce",
  null
  
)

export default component.exports